<template>
  <v-container>
    <client-manager></client-manager>
  </v-container>
</template>

<script>
import ClientManager from "@/components/ClientManager";
export default {
  name: "client",
  components: { ClientManager }
};
</script>
